// Thin wrapper so call sites stay one-liners and can evolve independently.
import { track as posthogTrack } from '../config/posthog';

export function track(event: string, props?: Record<string, unknown>) {
  posthogTrack(event, props);
}
